// extracted by mini-css-extract-plugin
export default {"card":"mobileTabSwitcher_card__x3Gq2","tabsContainer":"mobileTabSwitcher_tabsContainer__m2gWs"};